export default class FilterButtonInstance {
	/**
	 * FilterButtonContainer
	 *
	 * The class of the container in which the filtering should be applied.
	 */
	filterButtonContainer;

	/**
	 * filterContainerChildren
	 *
	 * Stores all children of the container in which the filtering should be applied.
	 */
	filterContainerChildren;

	/**
	 * filterContainerChildDiplayValue
	 *
	 * The previous css display value of the filtered items so that it will be correctly applied when it's toggled.
	 */
	filterContainerChildDiplayValue;

	/**
	 * filterAttribute
	 *
	 * The name of the data-attribute that should be compared with while filtering.
	 */
	filterAttribute;

	constructor( filterButtonContainer ) {
		// Pull out values for which data-attribute and within which container the filtering should be applied from the passed filter button container.
		const { filterFor, filterAttribute } = filterButtonContainer.dataset;

		// Save all children of the container we wish to filter within.
		this.filterContainerChildren = document.querySelectorAll( `.${ filterFor } > *` );

		// Bail if there are no children.
		if ( this.filterContainerChildren.length < 1 ) {
			return;
		}

		// Populate the rest of the variables.
		this.filterButtonContainer = filterButtonContainer;
		this.filterContainerChildDiplayValue = window.getComputedStyle( this.filterContainerChildren[ 0 ] ).display;
		this.filterAttribute = filterAttribute;

		// Add eventlisteners to all filter buttons.
		this.addFilterButtonEventListeners( filterButtonContainer );
	}

	/**
	 * addFilterButtonEventListeners
	 *
	 * @description Adds eventlisteners to all filterbuttons which triggers applyFilterToFilterTarget.
	 *
	 * @param {Node} filterButtonContainer
	 */
	addFilterButtonEventListeners( filterButtonContainer ) {
		const filterButtons = filterButtonContainer.querySelectorAll( '.filter-button__label' );

		filterButtons.forEach( filterButton => {
			const filterValue = filterButton.dataset.filterValue;

			filterButton.addEventListener( 'click', () => this.applyFilterToFilterTarget( filterValue ) );
		} );
	}
	/**
	 * applyFilterToFilterTarget
	 *
	 * @description Iterates over all children in filterContainerChildren and toggles their visibility depending
	 * on if the value of their data-attribute corresponds with the passed filterValue.
	 *
	 * @param {string} filterValue
	 */
	applyFilterToFilterTarget( filterValue ) {
		this.filterContainerChildren.forEach( child => {
			const currentValue = child.dataset[ this.filterAttribute ];

			if ( currentValue !== filterValue && filterValue !== '' ) {
				child.style.display = 'none';
			} else {
				child.style.display = this.filterContainerChildDiplayValue;
			}
		} );
	}
}
